import { Card, Form, Input } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { isUri } from 'valid-url';

export const StyledCard = styled(Card)`
  &&& {
    margin-top: 15px;
  }
  &&& .ant-card-body {
    padding: 0;
    margin: -1px 0 0 -1px;
  }
  &&& .ant-card-grid {
    width: 100%;
    padding: 12px;
  }
`;

const PortalGrid = StyledCard.Grid;

const PortalConfiguration = () => {
  const { t } = useTranslation('geosecma-settings');

  const validateUrl = (_: any, url: string) => {
    const isValid = isUri(url);

    if (isValid) {
      return Promise.resolve();
    }

    return Promise.reject(Error(t('urlValidationError')));
  };

  return (
    <StyledCard title={t('portalTab')} size="small" type="inner">
      <PortalGrid hoverable={false}>{t('portalExplanation')}</PortalGrid>
      <PortalGrid hoverable={false}>
        <Form.Item
          name="portalUrl"
          label={t('portalUrl')}
          rules={[{ required: true, message: t('urlRequired') }, { validator: validateUrl }]}
        >
          <Input
            data-testid="portalUrlInput"
            aria-label={t('portalUrl')}
            placeholder="https://host.domain.com/portal"
          />
        </Form.Item>
        <Form.Item name="appId" label={t('appId')}>
          <Input data-testid="portalAppIdInput" aria-label={t('appId')} placeholder={t('appId')} />
        </Form.Item>
      </PortalGrid>
    </StyledCard>
  );
};

export default PortalConfiguration;
